import { useState } from "react";
import AttachmentPreviewModal from "../../../../components/modals/AttachmentPreviewModal";
import { useAttachmentPreview } from "../../../../utils/hooks/useAttachmentPreview";
import AttachmentCard from "../../../../components/common/AttachmentCard";
import { useFetchRepAttachemnts } from "../../../../utils/hooks/IndReport";
import { CloseOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";

const ARAttachments = ({
  numericAuditStoreId,
  handleDownloadClick,
  primaryColor,
}) => {
  const { data: attachmentData = [] } = useFetchRepAttachemnts(
    `audit_store/${numericAuditStoreId}/attachment`,
  );
  const { getPreviewConfig, getModalPreviewSrc } =
    useAttachmentPreview(attachmentData);

  const [prevUrl, setPrevUrl] = useState(null);
  const [directUrl, setDirectUrl] = useState(null);
  const [isAuditReportOpen, setIsAuditReportOpen] = useState(true);
  const [previewAttachment, setPreviewAttachment] = useState(null);

  return (
    attachmentData.length > 0 && (
      <div className="card">
        <div
          className="card-header"
          onClick={() => setIsAuditReportOpen((prev) => !prev)}
          style={{
            backgroundColor: primaryColor || undefined,
            color: primaryColor ? "#fff" : undefined,
          }}
        >
          <p className="m-0">Attachments</p>
          {!isAuditReportOpen ? <UpOutlined /> : <DownOutlined />}
        </div>

        <div className={`${isAuditReportOpen ? "" : "d-none"} d-flex gap-3`}>
          <div className="d-inline-block">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                alignItems: "center",
              }}
            >
              {attachmentData.length ? (
                attachmentData.map((att) => (
                  <AttachmentCard
                    key={att.id}
                    attachment={att}
                    previewConfig={getPreviewConfig(att)}
                    onPreview={setPreviewAttachment}
                  />
                ))
              ) : (
                <p className="mx-2">
                  No attachments available for this section.
                </p>
              )}
            </div>
          </div>

          {/* ==================================== Modals ============================ */}
          {prevUrl && (
            <div className="fullscreen-preview">
              <div className="overlay" onClick={() => setPrevUrl(null)}></div>
              <div className="preview-content">
                <button className="close-btn" onClick={() => setPrevUrl(null)}>
                  <CloseOutlined />
                </button>

                {attachmentData.find((item) => item.direct_url === prevUrl)
                  ?.proof_type === "PHOTO" && (
                  <img src={prevUrl} alt="Preview" className="preview-image" />
                )}

                {attachmentData.find((item) => item.direct_url === prevUrl)
                  ?.proof_type === "VIDEO" && (
                  <video controls className="preview-video">
                    <source src={prevUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
                {attachmentData.find((item) => item.direct_url === prevUrl)
                  ?.proof_type === "AUDIO" && (
                  <audio controls className="preview-audio">
                    <source src={prevUrl} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                )}
                <div
                  className="download-btn"
                  onClick={() => handleDownloadClick(directUrl)}
                >
                  <img
                    src="downImg"
                    alt="Download Icon"
                    className="download-icon"
                  />
                  <p>Download</p>
                </div>
              </div>
            </div>
          )}

          {previewAttachment && (
            <AttachmentPreviewModal
              open={!!previewAttachment}
              attachment={{
                ...previewAttachment,
                direct_url: getModalPreviewSrc(previewAttachment),
              }}
              onClose={() => setPreviewAttachment(null)}
            />
          )}
        </div>
      </div>
    )
  );
};

export default ARAttachments;
